export default __webpack_public_path__ + "static/menina-planta-gato-93bab7607638cee2284da19eeedeacac.webp";